export enum MeasurementSystem {
    METRIC = 'metric',
    IMPERIAL = 'imperial',
}

export const MeasurementSystemOptions = [
    { value: MeasurementSystem.METRIC, label: 'Metric' },
    { value: MeasurementSystem.IMPERIAL, label: 'Imperial' },
];
